import { unauthenticateUser } from '../../actions/auth';
import connectAsync from '../../utils/connectAsync';
import PinCodeRouteLoader from './PinCodeRouteLoader';

export default connectAsync([unauthenticateUser])(PinCodeRouteLoader);
